<section>
  <app-form-header></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-input [control]="form.controls['recipientEmailAddress']" [type]="'email'" [inputMode]="'email'"></astral-input>
        <astral-input [control]="form.controls['subject']"></astral-input>
        <astral-textarea [control]="form.controls['body']" [rows]="12"></astral-textarea>
      </section>
      <div class="astral-form-actions">
        <astral-button type="button" variant="secondary" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
        <astral-button type="button" variant="primary" labelKey="SEND_BTN" [disabled]="form.invalid" (click)="send()"></astral-button>
      </div>
    </form>
  }
</section>
